import { render, staticRenderFns } from "./CmfPickupStep3.vue?vue&type=template&id=a37a2f8e&scoped=true"
import script from "./CmfPickupStep3.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37a2f8e",
  null
  
)

export default component.exports